import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6159beef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-price-type-component" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceTypesToView, (priceType) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (_ctx.selectPriceType(priceType.id)),
        key: priceType.id
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["priceTypeBox", { disabled: priceType.disabled }])
        }, _toDisplayString(_ctx.getPriceTypeName(priceType, _ctx.currentLanguageId)), 3)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}